<template>
  <div>
    <el-collapse-item title="前程信息采集表" name="qc_from_basic">
      <!--前程字段start-->
      <el-row>
        <el-col :span="2">手机号</el-col>
        <el-col :span="6">
          <el-input v-model="formData.mobile" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">微信号</el-col>
        <el-col :span="6">
          <el-input v-model="formData.wechat" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">QQ号</el-col>
        <el-col :span="6">
          <el-input v-model="formData.qq" class="jm-input-common7" readonly />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">姓名</el-col>
        <el-col :span="6">
          <el-input v-model="formData.name" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">是否有护照</el-col>
        <el-col :span="6">
          <el-input v-model="formData.has_passport_str" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">护照拼音名</el-col>
        <el-col :span="6">
          <el-input v-model="formData.name_pinyin" class="jm-input-common7" readonly />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">出生日期</el-col>
        <el-col :span="6">
          <el-input v-model="formData.birthday" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">毕业院校</el-col>
        <el-col :span="6">
          <el-input v-model="formData.final_school" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">毕业时间</el-col>
        <el-col :span="6">
          <el-input v-model="formData.final_time" class="jm-input-common7" readonly />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">专业名称</el-col>
        <el-col :span="6">
          <el-input v-model="formData.major" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">GPA算术平均分</el-col>
        <el-col :span="6">
          <el-input v-model="formData.gpa_suanshu" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">GPA加权平均分</el-col>
        <el-col :span="6">
          <el-input v-model="formData.gpa_jiaquan" class="jm-input-common7" readonly />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">GPA绩点</el-col>
        <el-col :span="6">
          <el-input v-model="formData.gpa_jidian" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">16年以上教育</el-col>
        <el-col :span="6">
          <el-input v-model="formData.is_16_str" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">若否说明原因</el-col>
        <el-col :span="6">
          <el-input v-model="formData.is_16_note" class="jm-input-common7" readonly />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">JLPT等级</el-col>
        <el-col :span="6">
          <el-input v-model="formData.jlpt_level" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">JLPT总分</el-col>
        <el-col :span="6">
          <el-input v-model="formData.jlpt_score" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">J-TEST等级</el-col>
        <el-col :span="6">
          <el-input v-model="formData.jtest_level" class="jm-input-common7" readonly />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">TOEFL总分</el-col>
        <el-col :span="6">
          <el-input v-model="formData.toefl_score" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">IELTS总分</el-col>
        <el-col :span="6">
          <el-input v-model="formData.ielts_score" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">TOEIC总分</el-col>
        <el-col :span="6">
          <el-input v-model="formData.toeic_score" class="jm-input-common7" readonly />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">专业英语等级</el-col>
        <el-col :span="6">
          <el-input v-model="formData.zhuanye_level" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">CET等级</el-col>
        <el-col :span="6">
          <el-input v-model="formData.cet_level" class="jm-input-common7" readonly />
        </el-col>
        <el-col :span="2">CET总分</el-col>
        <el-col :span="6">
          <el-input v-model="formData.cet_score" class="jm-input-common7" readonly />
        </el-col>
      </el-row>
      <!--前程字段end-->
    </el-collapse-item>
  </div>
</template>

<script>
export default {
  name: 'QcInfoForm',
  props: {
    userId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      formData: {}
    };
  },
  methods: {
    getUserQcinfo() {
      this.$http._post({
        url: '/index/student/getUserQcinfo',
        data: { userId: this.userId }
      }).then(({ data }) => {
        data.has_passport_str = '';
        data.is_16_str = '';
        this.formData = data;
        this.formData.has_passport_str = (this.formData.has_passport === '1' || this.formData.has_passport === 1) ? '是' : '否';
        this.formData.is_16_str = (this.formData.is_16 === '1' || this.formData.is_16 === 1) ? '是' : '否';
      });
    },
  },
  mounted() {
    if (parseInt(this.userId, 10)) {
      this.getUserQcinfo();
    }
  }
};
</script>
